import React from 'react';
import { LoadingIndicator } from './styles';
const ProgressBar = ({ progress, lightMode }) => {
    return React.createElement(LoadingIndicator, { progress: progress, lightMode: lightMode });
};
export default ProgressBar;
//# sourceMappingURL=index.js.map